require('./ProgramDescription.scss');
require('./_Type/ProgramDescription_Type_Content.scss');
require('./_Type/ProgramDescription_Type_Header.scss');
require('./_Type/ProgramDescription_Type_Schedule.scss');

const b = require('app/www/libs/b')('program-description');

const React = require('react');
const PropTypes = require('prop-types');

const {withI18nRef} = require('app/www/components/contexts/I18n');

const ResizeListener = require('app/www/components/blocks/ResizeListener/ResizeListener');
const Ua = require('app/www/components/blocks/Ua/Ua');

const nextTick = require('app/www/libs/nextTick');

const CALLBACK_DELAY = 300;

class ProgramDescription extends React.PureComponent {

    constructor(props) {
        super(props);

        const {
            mods,
            lineNumber,
            lineHeight,
            description,
            forceButton,
        } = this.props;

        this._maxHeight = lineNumber * lineHeight;
        this._paragraphs = mods.type !== 'header' ? this._makeParagraphs() : description;

        this.state = {
            button: forceButton,
            maxHeight: this._maxHeight,
        };

        this.open = this.open.bind(this);
        this._onResize = this._onResize.bind(this);
    }

    componentDidMount() {
        nextTick(() => {
            const {mods, callback} = this.props;

            this.setState({
                button: this._button,
                displayWidth: Ua.displayWidth,
            });

            if (mods.type === 'schedule') {
                setTimeout(callback, CALLBACK_DELAY);
            }
        });
    }

    render() {
        const {i18n, mods, description, buttonText} = this.props;
        const {maxHeight, button} = this.state;

        mods.button = button;

        const style = maxHeight ? {
            maxHeight: `${maxHeight}px`,
        } : {};

        const resizeListenerProps = {
            callback: this._onResize,
        };

        return (
            <div className={b(mods)} style={style}>
                <div className={b('content')} ref={ref => (this._content = ref)}>
                    {this._paragraphs}
                </div>
                {button && (
                    <i className={b('button')} onClick={this.open}>
                        {buttonText || i18n.get('program-description.button')}
                    </i>
                )}
                <meta itemProp="description" content={description} />
                <ResizeListener {...resizeListenerProps} />
            </div>
        );
    }

    /**
     * Раскрываем описание
     * @param {Object} [evt]
     */
    open(evt) {
        if (evt) {
            evt.stopPropagation();
        }

        const {forceButton, callback} = this.props;
        const {button} = this.state;

        if (!forceButton && button) {
            this.setState({
                button: false,
                maxHeight: this._content.offsetHeight,
            });
        }

        nextTick(callback);
    }

    /**
     * Показывать ли кнопку
     * @returns {Boolean}
     * @private
     */
    get _button() {
        const {forceButton} = this.props;
        const isCollapsed = Boolean(this._maxHeight) && this._maxHeight < this._content.offsetHeight;

        return forceButton || isCollapsed;
    }

    /**
     * Строим абзацы
     * @returns {Object[]}
     * @private
     */
    _makeParagraphs() {
        const {description} = this.props;

        return description.split('\n').map(paragraph => {
            paragraph = paragraph.trim();

            if (paragraph) {
                return <p key={paragraph} className={b('paragraph')}>{paragraph}</p>;
            }
        }).filter(Boolean);
    }

    /**
     * При изменении ширины браузера схлопываем блок
     * @private
     */
    _onResize() {
        const {displayWidth} = this.state;

        if (displayWidth !== Ua.displayWidth) {
            this.setState({
                button: this._button,
                maxHeight: this._maxHeight,
                displayWidth: Ua.displayWidth,
            });
        }
    }

}

ProgramDescription.defaultProps = {
    mods: {},
    description: '',
    lineNumber: 0,
    lineHeight: 0,
    callback: () => {},
};

ProgramDescription.propTypes = {
    description: PropTypes.string.isRequired,
    lineNumber: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.number,
    ]),
    lineHeight: PropTypes.number,
    buttonText: PropTypes.string,
    forceButton: PropTypes.bool,
    callback: PropTypes.func,
};

module.exports = withI18nRef(ProgramDescription);
